import React from 'react';
import type { DayInfo } from './roleInterfaces';
import { NeedRowsToggleButton } from './RolesTableRow';
import { HolidayStar } from './RolesTableCell';

interface HolidayIndicatorRowProps {
    label: string;
    days: DayInfo[];
    expanded: boolean;
    onToggle: () => void;
}

// Collapsed form of the holiday need block: one thin row that only flags the holidays of the week.
export default function HolidayIndicatorRow({ label, days, expanded, onToggle }: Readonly<HolidayIndicatorRowProps>) {
    return (
        <tr>
            <td className="border border-gray-300 align-middle text-xs font-bold text-gray-900 bg-white px-2 whitespace-nowrap">
                <div className="flex items-center justify-between gap-3">
                    <span>{label}</span>
                    <NeedRowsToggleButton expanded={expanded} onToggle={onToggle}/>
                </div>
            </td>
            <td className="border border-gray-300 bg-white p-0"></td>
            {days.map(day => (
                <td key={day.date} className="border border-gray-300 bg-white h-8 text-center align-middle">
                    {day.isHoliday && <HolidayStar/>}
                </td>
            ))}
            <td className="border border-gray-300 bg-white"></td>
        </tr>
    );
}
